import { SeasonKey } from 'modules/AwdMapView/seasonsConfig';

export const AWD_SEASONS_ID_MAP: Record<string, SeasonKey> = {
	// '0': 'NO_CROP_SEASON',
	// '201': 'KHARIF_2020',
	// '202': 'RABI_2020',
	// '211': 'KHARIF_2021',
	// '212': 'RABI_2021',
	'221': 'KHARIF_2022',
	'222': 'RABI_2022',
	// '231': 'KHARIF_2023',
	'232': 'RABI_2023',
	'241': 'KHARIF_2024',
	'242': 'RABI_2024',
	'251': 'KHARIF_2025',
	'252': 'RABI_2025',
	'261': 'KHARIF_2026',
	// '262': 'RABI_2026',
	// '271': 'KHARIF_2027',
	// '272': 'RABI_2027',
	// '281': 'KHARIF_2028',
	// '282': 'RABI_2028',
	// '291': 'KHARIF_2029',
	// '292': 'RABI_2029',
	// '301': 'KHARIF_2030',
	// '302': 'RABI_2030',
	// '311': 'KHARIF_2031',
	// '312': 'RABI_2031',
	// '321': 'KHARIF_2032',
	// '322': 'RABI_2033',
};
